
import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { CourseModule } from '../../store/modules/course'
import connect from './Connects.vue'
  @Component({
    components: { connect }
  })
export default class Second extends Vue {
    @Prop() type: boolean
    @Prop() campus: string
    @Prop() teacher: string
    @Prop() start_time: string
    @Prop() end_time: string
    @Prop() is_select: boolean

    tableData: any = []

    @Watch('is_select') 
    getSelect(newVal, oldVal) {
      if(newVal) {
        this.getList()
      }
    }

    mounted() {
      this.getList()
    }
    async getList() {
      const res:any = await CourseModule.getPerformance({ types: 'connect', campus: this.campus, teacher: this.teacher, start_time: this.start_time, end_time: this.end_time})
      if (res.code === 200) {
        this.tableData = res.data
        this.$emit('up-data', { type: true })
      }
    }
  
}
